const counties = [
  'ALAMEDA',
  'MARIN',
  'SAN FRANCISCO',
  'SANTA CLARA',
  'SAN MATEO'
];
const lgtConditionChoices = ['DAY', 'NIGHT'];
const weatherChoices = ['CLEAR', 'RAIN', 'HAIL', 'SNOW', 'FOG', 'CROSSWIND'];
const days = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
];

export { counties, lgtConditionChoices, weatherChoices, days };
